export default function () {
  return {
    activeTheme: 'light', // 'light', 'dark', 'beige', 'dark-blue'
    activeTab: 'presets', // 'presets', 'modules', 'mechanism', 'plate'
    activeTabMechanism: 'type', // 'type', 'color'
    activeTabPlate: 'indoor', // 'interior', 'exterior'
    preset: {
      id: 'preset-1',
      label: 'Preconfiguración 1',
      image: require('src/assets/forza/preconfiguraciones/FZA29S1.png')
    },
    custom: {},
    cart: {},
    getTotalPrice: 0
  }
}
